import { memo, useMemo } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Badge } from '@mui/material';
// redux
import { useSelector } from '../../../redux/store';
import { selectConversations } from '../../../redux/slices/internalChat';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// config
import { HEADER } from '../../../config';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
//
import navConfig from './NavConfig';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  // Total de mensagens não lidas no chat interno
  const conversations = useSelector(selectConversations);
  const internalChatUnread = useMemo(
    () => (conversations || []).reduce((sum, c) => sum + (c.unreadCount || 0), 0),
    [conversations]
  );

  // Injeta o badge no item "Chat Interno" dinamicamente
  const navConfigWithBadge = useMemo(() => navConfig.map((section) => ({
    ...section,
    items: section.items.map((item) => {
      if (item.path === PATH_DASHBOARD.internalChat?.root && internalChatUnread > 0) {
        return {
          ...item,
          info: (
            <Badge
              badgeContent={internalChatUnread > 99 ? '99+' : internalChatUnread}
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.6rem',
                  height: 16,
                  minWidth: 16,
                  px: 0.5,
                }
              }}
            />
          ),
        };
      }
      return item;
    }),
  })), [internalChatUnread]);

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={navConfigWithBadge} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);

